import Navbar from "../components/navbar";
import Footer from "../components/footer";
import Hero from "../components/hero";
import AboutUs from "../components/about_us";
import DailyFood from "../components/daily_food";
import FoodEdu from "../components/food_edu";
import Testimoni from "../components/testimoni";
import Contact from "../components/contact";
import CustomerService from "../components/customor_service";

export default function PublicLayout() {
    return (
      <>
        <Navbar />
        <Hero />
        <AboutUs/>
        <DailyFood/>
        <FoodEdu/>
        <Testimoni/>
        <Contact/>
        <CustomerService/>
        <Footer />
      </>
    )
}